import { css } from 'lit';

export const clearButton = css`
  .clear-button,
  .warning-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: 0;
    border: none;
    background: none;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 12;
    right: 0;
    bottom: 0;
    width: 30px;
    height: 4.5rem;
    margin-right: 0.7rem;
    cursor: pointer;
  }
  .clear-button:focus,
  .warning-button:focus {
    outline: none;
  }
  .clear-button:after {
    content: 'X';
    background-color: #cccccc;
    border-radius: 50%;
    text-align: center;
    width: 15px;
    height: 15px;
    line-height: 15px;
    font-size: 10px;
    color: #ffffff;
    display: inline-block;
  }
  .warning-button:after {
    content: '!';
    background-color: #ff0322;
    border-radius: 50%;
    text-align: center;
    width: 15px;
    height: 15px;
    line-height: 15px;
    font-size: 10px;
    color: #fff;
    display: inline-block;
  }
`;
